module.exports = __webpack_public_path__ + "static/media/my-invoice-history-active.0271b0f8.svg";